/**
 *
 * Requres Slick Slider
 * https://kenwheeler.github.io/slick/
 *
 *
 */
 // *************************
 // *
 // * Artists Slide
 // *************************


jQuery(document).ready(function ($) {

      /* Click to close lightbox */
      function closeArtistLightbox(){
        document.body.style.overflow='auto';
        // $(".artist-slideshow:visible").slick('unslick');
        $('.stellar-artist-slider').removeClass('show');
        $('.stellar-artist-slider').hide();
      }

      $('.stellar-artist-slider').click(function (e) {
          var $tgt = $(e.target);
          if (! $tgt.closest(".lightbox-content").length) {
            closeArtistLightbox($(this));
          }
      });

      $('.btn-close').click(function(e){
          e.preventDefault();
          closeArtistLightbox($(this));
      });
      /* END OF Click to close lightbox */


      /* Slick Slider lightbox */
      // $('.stellar-artist-slider').hide();
      $(".artist-slideshow").slick({
           dots: false,
           infinite: false,
       });


       $("a.stellar-artist").click(function(e){
           e.preventDefault();
           $target =  $(this).parent().next('.stellar-artist-slider');
           $target.show();

           setTimeout(function() {
             $target.addClass('show');
           }, 500);




            document.body.style.overflow='hidden';  //stop page scroll
             slideIndex = $(this).index();
             // $( '.artist-slideshow' ).slickGoTo( parseInt(slideIndex) );
              $( '.artist-slideshow' ).slick( 'slickGoTo', parseInt(slideIndex) );

       });

        /* END OF Slick Slider lightbox */

});
